// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3qWc4","amount":"Amount_amount__26tSU","tip":"Amount_tip__23Ghw","tipHeader":"Amount_tipHeader__32MKt","tipsWrap":"Amount_tipsWrap__2DlZm"};